import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LabProvidersResponse, LabProvidersState } from "./index.types";

export const initialLabProvidersState: LabProvidersState = {
  labProvidersData: [],
  labProvidersDataOptions: [],
  labProvidersSuccess: null,
  labProvidersIsLoading: false,
};

const name = "labProviders";

export const labProvidersSlice = createSlice({
  name,
  initialState: initialLabProvidersState,
  reducers: {
    getLabProviders: (state) => {
      state.labProvidersIsLoading = true;
    },
    getLabProvidersSuccess: (state, action: PayloadAction<LabProvidersResponse>) => {
      state.labProvidersSuccess = true;
      state.labProvidersIsLoading = false;
      state.labProvidersData = action.payload.results;
      state.labProvidersDataOptions = action.payload?.results?.map((s) => ({
        label: s?.name,
        value: s?.id,
      }));
    },
    getLabProvidersFail: (state) => {
      state.labProvidersSuccess = false;
      state.labProvidersData = [];
      state.labProvidersIsLoading = false;
      state.labProvidersDataOptions = [];
    },
    clearLabProvidersData: (state) => {
      state.labProvidersSuccess = null;
      state.labProvidersData = [];
      state.labProvidersIsLoading = false;
      state.labProvidersDataOptions = [];
    },
  },
});

export const { clearLabProvidersData } = labProvidersSlice.actions;

export default labProvidersSlice.reducer;

export const getLabProvidersList = () => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/labproviders/`,
  },
  type: "getLabProviders",
});
